import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";
import SelectPaysprintBank from "./SelectPaysprintBank";

export default function AddAccountModal({ show, onClose, onSuccess }) {
  const { userid } = useSession();

  const [form, setForm] = useState({
    bankname: "",
    name: "",
    account: "",
    ifsccode: "",
  });

  const [bankCode, setBankCode] = useState("");
  const [showBankModal, setShowBankModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.bankname) newErrors.bankname = "Bank is required";
    if (!bankCode) newErrors.bankname = "Please select a bank";
    if (!form.name.trim()) newErrors.name = "Name is required";
    if (!form.account.trim()) newErrors.account = "Account is required";
    if (!form.ifsccode.trim()) newErrors.ifsccode = "IFSC is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please fill all fields", "danger");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("userid", userid);
      formData.append("bankname", form.bankname);
      formData.append("bankid", bankCode); // ✅ FIXED
      formData.append("name", form.name);
      formData.append("account", form.account);
      formData.append("ifsccode", form.ifsccode);
      formData.append("account_type", "PRIMARY");

      const res = await fetch(
        "https://pro.mokshiq.in/add_beneficiary_bank",
        {
          method: "POST",
           headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
          body: formData,
        }
      );

      const result = await res.json();

      if (result.status) {
        showMainToast(result.data || "Account added", "success");
        onClose();
        onSuccess();
      } else {
        showMainToast(result.data || "Failed to add account", "danger");
      }
    } catch (e) {
      showMainToast("Something went wrong", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BaseModal
        show={show}
        onClose={onClose}
        title="Add Settlement Account"
        footerButtons={[
          { label: "Cancel", className: "btn-secondary", dismiss: true },
          {
            label: loading ? "Saving..." : "Save",
            className: "btn-primary",
            onClick: handleSave,
          },
        ]}
      >
        <div className="card-body">
          <form className="row g-3">
            {/* Bank Name (Flutter-style selector) */}
            <div className="col-md-12">
              <label className="form-label">Bank Name</label>
              <input
                className={`form-control ${errors.bankname ? "is-invalid" : ""}`}
                value={form.bankname}
                placeholder="Select Bank Name"
                readOnly
                onClick={() => setShowBankModal(true)}
              />
              {errors.bankname && (
                <div className="text-danger">{errors.bankname}</div>
              )}
            </div>

            {/* Name */}
            <div className="col-md-12">
              <label className="form-label">Name</label>
              <input
                name="name"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                value={form.name}
                onChange={handleChange}
              />
              {errors.name && (
                <div className="text-danger">{errors.name}</div>
              )}
            </div>

            {/* Account */}
            <div className="col-md-12">
              <label className="form-label">Account</label>
              <input
                name="account"
                className={`form-control ${
                  errors.account ? "is-invalid" : ""
                }`}
                value={form.account}
                onChange={handleChange}
              />
              {errors.account && (
                <div className="text-danger">{errors.account}</div>
              )}
            </div>

            {/* IFSC */}
            <div className="col-md-12">
              <label className="form-label">IFSC Code</label>
              <input
                name="ifsccode"
                className={`form-control ${
                  errors.ifsccode ? "is-invalid" : ""
                }`}
                value={form.ifsccode}
                onChange={handleChange}
              />
              {errors.ifsccode && (
                <div className="text-danger">{errors.ifsccode}</div>
              )}
            </div>
          </form>
        </div>
      </BaseModal>

      {/* Bank Selector Modal */}
      <SelectPaysprintBank
        show={showBankModal}
        onClose={() => setShowBankModal(false)}
        onSelect={(bank) => {
          setForm((prev) => ({ ...prev, bankname: bank.bank_name }));
          setBankCode(bank.bank_id);
        }}
      />
    </>
  );
}
